var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-carousel',{attrs:{"after-change":_vm.onChange,"autoplay":true}},_vm._l((_vm.imgList),function(img,i){return _c('div',{key:'i'+i,staticClass:"item",class:_vm.radius?'radius':''},[_c('img',{attrs:{"src":img.url,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }